import { InterpolationExpressionMatcher } from 'ngx-transloco-markup';

export class MessageFormatInterpolationExpressionMatcher implements InterpolationExpressionMatcher {
  matchExpression(source: string, startOffset: number): number | undefined {
    let offset = startOffset;
    let level = 0;
    do {
      const character = source.charAt(offset);

      if (character === '{') {
        level++;
      }
      if (character === '}') {
        level--;
      }

      offset++;
    } while (level > 0 && offset < source.length);

    const expressionLength = offset - startOffset;

    return level === 0 && expressionLength > 1 ? expressionLength : undefined;
  }
}
